// 受支持语言的单一事实源（与 @/i18n 的 supportedLanguages 保持一致）。
//
// 抽离为无副作用模块：authRedirect.js 需要这份列表来做「不支持语言」校验，
// 但 @/i18n/index.js 在模块顶层调用 createI18n，直接 import @/i18n 会在
// jsdom 下触发 i18n 实例化副作用（见步骤 2 落地说明）。本模块仅导出纯数据，
// 任何调用方（含 authRedirect.js 与 @/i18n 自身）引入都不会产生副作用。
//
// 新增语言时只需改此处一处，@/i18n 与认证入口 resolver 自动同步。
export const SUPPORTED_LANGS = ['en', 'zh', 'ja']
